var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReachOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24047 10.76C9.10679 10.6266 8.94746 10.5216 8.7721 10.4514L3.22488 8.22689C3.15865 8.20031 3.10213 8.15411 3.06292 8.09449C3.0237 8.03486 3.00366 7.96467 3.00549 7.89333C3.00731 7.82199 3.03092 7.75291 3.07314 7.69537C3.11536 7.63783 3.17417 7.59459 3.24167 7.57144L16.5326 3.02454C16.5946 3.00215 16.6617 2.99788 16.726 3.01222C16.7903 3.02657 16.8492 3.05893 16.8958 3.10553C16.9424 3.15213 16.9748 3.21104 16.9891 3.27536C17.0035 3.33968 16.9992 3.40676 16.9768 3.46874L12.4299 16.7597C12.4068 16.8272 12.3635 16.886 12.306 16.9282C12.2484 16.9704 12.1794 16.994 12.108 16.9959C12.0367 16.9977 11.9665 16.9776 11.9068 16.9384C11.8472 16.8992 11.801 16.8427 11.7744 16.7765L9.54997 11.2278C9.47944 11.0526 9.37416 10.8935 9.24047 10.76ZM9.24047 10.76L16.8936 3.10848",
    stroke: "#6860EE",
    strokeWidth: 1.39905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachOutIcon);
export default __webpack_public_path__ + "static/media/reach-out-icon.5f75606755dbc13c0024528b445a6b9c.svg";
export { ForwardRef as ReactComponent };